/**
 * Created by @author @ddennis - ddennis.dk aka fantastisk.dk/works aka meresukker.dk on 29/07/2025.
 */
import React, { useEffect } from 'react'
import Spinner, { RoundSpinner } from './spinner/Spinner'
import useSWR from 'swr'
import { getReq } from '../service/API'

const NONE = 'NONE'
const CIRCLE = 'CIRCLE'
const BUBBLES = 'BUBBLES'
type SPINNER_TYPE = 'CIRCLE' | 'BUBBLES' | 'NONE'

type Props = {
  endpoint: string
  result: string
  callback: (result: any) => void
  spinnerType?: SPINNER_TYPE
}

export const PollEndpoint = ({ endpoint, result, callback, spinnerType = BUBBLES }: Props) => {
  const { data } = useSWR(endpoint, getReq, {
    suspense: false,
    refreshInterval: 1000,
    onSuccess: () => {
      console.log('PollEndpoint > onSuccess = ')
    },
  })

  useEffect(() => {
    console.log('PollEndpoint > data change = ')
    if (data.data && data.data === result) {
      console.log('PollEndpoint > what')
      callback(result)
    }
  }, [data, callback, result])

  if (spinnerType === NONE) {
    return null
  }

  return (
    <div className="col-12 px-4 justify-content-center d-flex align-items-center h-100 mb-6">
      {spinnerType === BUBBLES ? <Spinner></Spinner> : null}
      {spinnerType === CIRCLE ? <RoundSpinner size={50}></RoundSpinner> : null}
    </div>
  )
}

type AskProps = Props & { children: React.ReactNode; isPolling: boolean; spinnerType?: SPINNER_TYPE }

export const AskToPollEndpoint = ({
  children,
  endpoint,
  result,
  callback,
  isPolling = false,
  spinnerType,
}: AskProps) => {
  return (
    <>
      {children}

      {isPolling ? (
        <PollEndpoint endpoint={endpoint} callback={callback} result={result} spinnerType={spinnerType}></PollEndpoint>
      ) : null}
    </>
  )
}
